module.exports = __webpack_public_path__ + "static/k8s-dbf2390d8416171973b2abff6a64a9bf.png";